import { render, staticRenderFns } from "./prize-editor.vue?vue&type=template&id=1a8f766f&"
import script from "./prize-editor.vue?vue&type=script&lang=js&"
export * from "./prize-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports